import { Component, OnInit, ViewChild } from '@angular/core';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputNumberModule } from 'primeng/inputnumber';
import { DatePickerModule } from 'primeng/datepicker';
import { EkuroService, IClinicas } from './ekuro.service';
import { CommonModule, DatePipe } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoadingModalComponent } from '../../../loading-modal/loading-modal.component';
import { AlertComponent } from '../../../alert/alert.component';

@Component({
  selector: 'app-ekuro-integracao',
  standalone: true,
  imports: [
    CardModule,
    ButtonModule,
    DialogModule,
    TextareaModule,
    InputTextModule,
    FloatLabelModule,
    InputNumberModule,
    DatePickerModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ProgressSpinnerModule,
    LoadingModalComponent,
    AlertComponent,
  ],
  templateUrl: './ekuro-integracao.component.html',
  styleUrls: ['./ekuro-integracao.component.scss'],
  providers: [EkuroService, DatePipe],
})
export class EkuroIntegracaoComponent implements OnInit {
  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingComponent!: LoadingModalComponent;

  public visibilidadeModalCadastroClinica: boolean = false;
  public visibilidadeModalConfiguracaoClinica: boolean = false;

  public mostrarInformacoes: boolean = false;

  public listaDeClinicas!: Array<IClinicas>;
  public clinicaSelecionada!: IClinicas;

  public formularioInsercaoClinica!: FormGroup;
  public formularioEdicaoClinica!: FormGroup;
  constructor(
    private ekuroService: EkuroService,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {
    this.formularioInsercaoClinica = this.fb.group({
      nomeClinica: ['', [Validators.required]],
      clinicaId: ['', [Validators.required]],
      appAccessToken: ['', [Validators.required]],
      mensagemConfirmacaoConsulta: ['', [Validators.required]],
      mensagemLembreteConsulta: ['', [Validators.required]],
      somaDia: ['', [Validators.required]],
      horario: ['', [Validators.required]],
      queueId: ['', [Validators.required]],
      apiKey: ['', [Validators.required]],
      host: ['', [Validators.required]],
    });
  }

  async ngOnInit() {
    await this.listarClinicasCadastradas();
  }

  public listarClinicasCadastradas(): void {
    this.ekuroService
      .listarTodasAsClinicas()
      .subscribe((response: Array<IClinicas>) => {
        this.listaDeClinicas = response;
      });
  }

  public handleAbrirModalCadastroClinica(): void {
    this.visibilidadeModalCadastroClinica =
      !this.visibilidadeModalCadastroClinica;
  }

  public handleAbrirModalConfiguracaoClinica(clinicaObject: IClinicas): void {
    this.clinicaSelecionada = clinicaObject;
    this.formularioEdicaoClinica = this.fb.group({
      id: [this.clinicaSelecionada.id, [Validators.required]],
      nomeClinica: [this.clinicaSelecionada.nomeClinica, [Validators.required]],
      clinicaId: [this.clinicaSelecionada.clinicaId, [Validators.required]],
      appAccessToken: [
        this.clinicaSelecionada.appAccessToken,
        [Validators.required],
      ],
      mensagemConfirmacaoConsulta: [
        this.clinicaSelecionada.mensagemConfirmacaoConsulta,
        [Validators.required],
      ],
      mensagemLembreteConsulta: [
        this.clinicaSelecionada.mensagemLembreteConsulta,
        [Validators.required],
      ],
      somaDia: [this.clinicaSelecionada.somaDia, [Validators.required]],
      horario: [this.clinicaSelecionada.horario, [Validators.required]],
      queueId: [this.clinicaSelecionada.queueId, [Validators.required]],
      apiKey: [this.clinicaSelecionada.apiKey, [Validators.required]],
      host: [this.clinicaSelecionada.host, [Validators.required]],
    });

    this.visibilidadeModalConfiguracaoClinica =
      !this.visibilidadeModalConfiguracaoClinica;
  }

  public handleExecutarAoFecharModalCadastroClinica(): void {
    this.formularioInsercaoClinica.reset();
  }

  public handleExecutarAoFecharModalConfiguracaoClinica(): void {}

  public handleMostrarInformacoes(): void {
    this.mostrarInformacoes = !this.mostrarInformacoes;
  }

  public handleEnviarCadastroClinica(): void {
    this.visibilidadeModalCadastroClinica = false;
    this.loadingComponent.activeLoading();
    this.formularioInsercaoClinica.patchValue({
      somaDia: this.formularioInsercaoClinica.value.somaDia.toString(),
      horario: this.datePipe.transform(
        this.formularioInsercaoClinica.value.horario,
        'HH:mm'
      ),
    });

    this.ekuroService
      .cadastrarClinica(this.formularioInsercaoClinica.value)
      .subscribe(
        (response: any) => {
          this.loadingComponent.inactiveLoading();
          this.alertComponent.showAlert(`${response.status}`, 'success');
          this.listarClinicasCadastradas();
        },
        (error: any) => {
          this.loadingComponent.inactiveLoading();
          this.visibilidadeModalCadastroClinica = true;
          this.alertComponent.showAlert(
            'Erro ao tentar inserir clinica',
            'error'
          );
        }
      );
  }

  public handleEnviarAtualizacaoClinica(): void {
    this.loadingComponent.activeLoading();

    const horarioString = this.formularioEdicaoClinica.value.horario; // Ex: "17:11"
    let horarioDate: Date | null = null;

    if (horarioString && typeof horarioString === 'string') {
      const [horas, minutos] = horarioString.split(':').map(Number);
      horarioDate = new Date();
      horarioDate.setHours(horas, minutos, 0);
    }

    this.formularioEdicaoClinica.patchValue({
      somaDia: this.formularioEdicaoClinica.value.somaDia.toString(),
      horario: this.datePipe.transform(
        horarioDate,
        'HH:mm'
      ),
    });

      this.ekuroService
        .atualizarClinica(this.formularioEdicaoClinica.value)
        .subscribe(
          (response: any) => {
            this.alertComponent.showAlert(`${response.status}`, 'success');
            this.loadingComponent.inactiveLoading();
            this.visibilidadeModalConfiguracaoClinica = false;
            this.listarClinicasCadastradas();
          },
          (error: any) => {
            this.alertComponent.showAlert(`${error.error.status}`, 'error');
            this.loadingComponent.inactiveLoading();
          }
        );
  }

  public deletarClinica(idClinica: number): void {
    this.visibilidadeModalConfiguracaoClinica = false;
    this.loadingComponent.activeLoading();
    this.ekuroService.deletarClinica(idClinica).subscribe(
      (response: any) => {
        this.listarClinicasCadastradas();
        this.alertComponent.showAlert(`${response.status}`, 'success');
        this.loadingComponent.inactiveLoading();
      },
      (error: any) => {
        this.loadingComponent.inactiveLoading();
        this.alertComponent.showAlert(`${error.error.status}`, 'error');
      }
    );
  }
}
